import React, { useState, useEffect } from "react"
import { PAYMENT_METHODS_SEARCH } from "../../helpers/api_endpoints"
import { post } from "../../helpers/api_helper"
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Alert,
  Label,
  Input,
  Badge,
  FormGroup,
} from "reactstrap"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { Trans, useTranslation } from "react-i18next"
import Select from "react-select"
import { ITEMS_PER_PAGE } from "helpers/pagination_helper"

document.title = "Payment Methods"

function PaymentMethodList() {
  const { i18n } = useTranslation()
  const [paymentMethods, setPaymentMethods] = useState([])
  const [successMsg, setsuccessMsg] = useState("")
  const [filters, setFilters] = useState({})
  const [name, setName] = useState("")
  const [status, setStatus] = useState(1)
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)
  const [loading, setLoading] = useState(true)
  const paymentMethodStatus = [
    { value: 1, label: "Active" },
    { value: 0, label: "Inactive" },
  ]
  const getTranslatedText = (titleArray, defaultText) => {
    const langMap = { en: 1, ar: 2, ur: 3, fa: 4, ps: 5 }
    const langKey = langMap[i18n.language] || 1
    const titleObj = titleArray?.find(item => item[langKey])
    return titleObj ? titleObj[langKey] : defaultText
  }

  useEffect(() => {
    post(
      `${PAYMENT_METHODS_SEARCH}?paginate=${ITEMS_PER_PAGE}&page=${page}`,
      filters
    )
      .then(response => {
        const data = response.data
        setPaymentMethods(data.data)
        setTotalPages(data.pagination.totalPages)
        setPage(data.pagination.currentPage)
        setLoading(false)
      })
      .catch(error => {
        if (error.response.status == 400) {
          console.log(error)
        }
      })
  }, [page, filters])

  const handleFilter = (type, value) => {
    const filtvalues = { ...filters }
    if (value === "" || value === null || value === undefined) {
      delete filtvalues[type]
    } else {
      switch (type) {
        case "name":
          setName(value)
          filtvalues.name = value
          break
        case "status":
          filtvalues.status = value
          break
        default:
          break
      }
    }
    setPage(1)
    setFilters(filtvalues)
  }

  const handlePrevPage = () => {
    if (page > 1) {
      setPage(page - 1)
    }
  }

  const handleNextPage = () => {
    if (page < totalPages) {
      setPage(page + 1)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Row>
            <Col xl={12}>
              <Card>
                <br></br>
                {successMsg ? (
                  <Alert style={{ margin: "25px" }} color="success">
                    {successMsg}
                  </Alert>
                ) : null}
                <CardTitle>
                  <Link to="/payment-methods/add">
                    <button
                      style={{ float: "right", marginRight: "20px" }}
                      className="btn btn-sm btn-primary"
                    >
                      <i className="dripicons-plus"></i> &nbsp;
                      <Trans>Create</Trans>
                    </button>
                  </Link>
                </CardTitle>
                <div style={{ margin: "25px" }}>
                  <div className="row">
                    <div className="form-group col-md-3 mt-2">
                      <Label className="form-label">
                        <Trans>Name</Trans>
                      </Label>
                      <Input
                        name="name"
                        className="form-control"
                        placeholder=""
                        type="text"
                        onChange={e => handleFilter("name", e.target.value)}
                        onKeyDown={e => handleFilter("name", e.target.value)}
                      ></Input>
                    </div>
                    <div className="form-group col-md-2 mt-2">
                      <Label className="form-label">
                        <Trans>Status</Trans>
                      </Label>
                      <Select
                        name="orderStatusId"
                        options={paymentMethodStatus}
                        className="form-control select2"
                        isClearable
                        onChange={opt =>
                          handleFilter("status", opt ? opt.value : "")
                        }
                      />
                    </div>
                  </div>
                </div>
                <CardBody>
                  <div className="table-responsive">
                    <Table className="table table-striped table-bordered mb-0">
                      <thead>
                        <tr>
                          <th>
                            <Trans>ID</Trans>
                          </th>
                          <th>
                            <Trans>Name</Trans>
                          </th>
                          <th>
                            <Trans>Symbol</Trans>
                          </th>
                          <th>
                            <Trans>Status</Trans>
                          </th>
                          <th>#</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paymentMethods.map((paymentMethod, index) => (
                          <tr key={index}>
                            <td>{paymentMethod.id}</td>
                            <td>
                              {getTranslatedText(
                                paymentMethod.named?.title,
                                paymentMethod.name
                              )}
                            </td>
                            <td>
                              <img
                                src={paymentMethod.icon}
                                alt="paymentMethod"
                                style={{ width: "50px", height: "50px" }}
                              />
                            </td>
                            <td>
                              {
                                <Badge
                                  className={
                                    paymentMethod.isActive
                                      ? "bg-success"
                                      : "bg-danger"
                                  }
                                >
                                  <Trans>
                                    {paymentMethod.isActive
                                      ? "active"
                                      : "inactive"}
                                  </Trans>
                                </Badge>
                              }
                            </td>

                            <td>
                              <Link
                                to={`/payment-methods/edit/${paymentMethod.id}`}
                              >
                                <button className="btn btn-sm btn-info">
                                  <i className="dripicons-pencil"></i> &nbsp;
                                  <Trans>Edit</Trans>
                                </button>
                              </Link>{" "}
                              &nbsp;
                              <Link
                                to={`/payment-methods/remove/${paymentMethod.id}`}
                              >
                                <button className="btn btn-sm btn-danger">
                                  <i className="dripicons-trash"></i> &nbsp;
                                  <Trans>Remove</Trans>
                                </button>
                              </Link>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                  <br></br>
                  <div className="text-center">
                    {/* Pagination controls */}
                    <button
                      className="btn btn-sm btn-dark"
                      onClick={handlePrevPage}
                      disabled={page === 1}
                    >
                      <Trans>Previous</Trans>
                    </button>
                    &nbsp;
                    <button
                      className="btn btn-sm btn-dark"
                      onClick={handleNextPage}
                      disabled={page === totalPages}
                    >
                      <Trans>Next</Trans>
                    </button>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default PaymentMethodList
